import React, { useState } from 'react';
import { UiGrid } from '@open-stack/ui';
import { ButtonGroup } from '../../button/group/ButtonGroup';
import { useCurrency } from '../../../hooks/currency';
import { XText, XTextType } from '../../x/text/XText';
import { XInput } from '../../x/input/XInput';
import { useZone } from '../../../hooks/zone';
import styled from 'styled-components';
import { XButton, XCard } from '@orderx/lab/ui';

const Wrapper = styled(UiGrid)`
    .card {
        display: grid;
        grid-gap: var(--space4);
        padding: var(--space4);
        background: #111;
        border-radius: var(--space4);
    }
`;

interface Props {
    tipAmount: number;
    onChangeTipAmount(amount: number): void;

    totalCostInitial: number;
    tipPresets: number[];

    onContinue(): void;
    isLoading?: boolean;
}

export function TipForm({ tipAmount, onChangeTipAmount, totalCostInitial, tipPresets, onContinue, isLoading }: Props) {
    const { currency } = useZone();
    const { format, toNumber, calculateDiscount } = useCurrency(currency);
    const [isCustom, setIsCustom] = useState(false);

    let existingAmounts = new Set();

    const presetsAsAmounts = tipPresets
        .map((percent) => {
            const amount = totalCostInitial - calculateDiscount(totalCostInitial, percent);
            const exists = existingAmounts.has(amount);

            existingAmounts.add(amount);

            return {
                percent,
                amount: exists ? 0 : amount,
            };
        })
        .filter((item) => item.amount > 0);

    const isInputVisible = isCustom || presetsAsAmounts.length === 0;
    const totalCost = totalCostInitial + tipAmount;

    return (
        <Wrapper>
            <XCard padding={4}>
                <UiGrid>
                    <XText type={XTextType.TITLE} align={'center'}>
                        Do you wish to leave TIP?
                    </XText>

                    {presetsAsAmounts.length > 0 && (
                        <ButtonGroup>
                            {presetsAsAmounts.map(({ percent, amount }) => (
                                <XButton
                                    onClick={() => {
                                        onChangeTipAmount(amount === tipAmount ? 0 : amount);
                                    }}
                                    key={percent}
                                    color={tipAmount === amount ? 'secondary' : 'default'}
                                    variant={tipAmount === amount ? 'filled' : 'outlined'}>
                                    {percent}%
                                </XButton>
                            ))}

                            <XButton
                                onClick={() => setIsCustom(!isCustom)}
                                color={isInputVisible ? 'secondary' : 'default'}
                                variant={isInputVisible ? 'filled' : 'outlined'}>
                                Other
                            </XButton>
                        </ButtonGroup>
                    )}

                    {isInputVisible && (
                        <XInput
                            value={tipAmount || ''}
                            onChangeValue={(value) => {
                                onChangeTipAmount(value < 0 ? 0 : toNumber(value));
                            }}
                            label="Tip amount"
                            type="currency"
                        />
                    )}
                </UiGrid>
            </XCard>

            <XButton onClick={() => onContinue()} isLoading={isLoading} color={'primary'} className={'cta'}>
                {tipAmount ? <>Place order {format(totalCost)}</> : <>No tip</>}
            </XButton>
        </Wrapper>
    );
}
